import { humanizeRecurringSchedule, jobIsRecurrent } from '~/utils/recurring_schedule';
import { recurringJobsDialogEvents } from '~/utils/work_orders';
import { mapInertiaProps } from '~/utils/inertia';
import { USER_ROLES_ENUM } from '~/app_constants';
import WorkOrdersConfirmDeleteRecurringJobsDialog from '~/components/work_orders/WorkOrdersConfirmDeleteRecurringJobsDialog.vue';

const confirmDeleteRecurringJobsDialog = WorkOrdersConfirmDeleteRecurringJobsDialog.name;

export default {
  data: () => ({
    deletingJob: null,
  }),
  computed: {
    ...mapInertiaProps({
      canDestroySchedules({ current_user: currentUser }) {
        return [USER_ROLES_ENUM.Owner, USER_ROLES_ENUM.Manager].includes(currentUser.role);
      },
    }),
  },
  methods: {
    jobIsRecurrent,
    scheduleTooltip(schedule) {
      return humanizeRecurringSchedule(schedule);
    },
    async confirmDeleteJob(job) {
      if (this.jobIsRecurrent(job)) {
        return new Promise((resolve) => {
          recurringJobsDialogEvents.open(confirmDeleteRecurringJobsDialog, {
            dialogEvents: {
              confirm: async (event) => {
                const payload = { job, isAllSelected: event, isSingleJob: !event };
                const response = await this.onDeleteJob(payload, false);

                recurringJobsDialogEvents.close(confirmDeleteRecurringJobsDialog);
                resolve(response);
              },
              cancel: () => {
                recurringJobsDialogEvents.close(confirmDeleteRecurringJobsDialog);
                resolve();
              },
            },
          });
        });
      }

      // `onDeleteJob` comes from the WorkOrderJobActions mixin
      // Pass `isAllSelected` true as we are deleting a one-off job
      // via the schedules endpoint.
      return this.onDeleteJob({ job, isAllSelected: true, isSingleJob: true });
    },
  },
};
